import { EDeliverableStatus } from '@constants';
import { Popover, Tag } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as key } from 'uuid';

import { Icon } from '../Icon';

import { SelectorWrapper, InnerTagWrapper } from './DeliverableStatusBadge.styles';

type Props = {
  status?: EDeliverableStatus;
  isEditable?: boolean;
  onChange?: (status: EDeliverableStatus) => void;
};

export const DeliverableStatusBadge: React.FC<Props> = ({
  status,
  isEditable = false,
  onChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  if (!status) return null;

  const getStatusColor = (s: EDeliverableStatus) => {
    switch (s) {
      case EDeliverableStatus.IN_REVIEW:
        return 'default';
      case EDeliverableStatus.COMPLETED:
        return 'success';
      case EDeliverableStatus.DELIVERED:
        return 'warning';
      default:
        return 'default';
    }
  };

  const handleOpen = (o: boolean) => {
    if (!isEditable) return;
    setIsOpen(o);
  };

  const handleOnChange = (s: EDeliverableStatus) => {
    if (!isEditable) return;
    onChange?.(s);
    setIsOpen(false);
  };

  const content = (
    <SelectorWrapper>
      {Object.values(EDeliverableStatus).map(s => (
        <Tag key={key()} color={getStatusColor(s)} onClick={() => handleOnChange(s)}>
          <InnerTagWrapper>{t(s)}</InnerTagWrapper>
        </Tag>
      ))}
    </SelectorWrapper>
  );

  return (
    <Popover
      open={isOpen}
      content={content}
      placement="bottom"
      trigger={['click']}
      onOpenChange={handleOpen}>
      <Tag color={getStatusColor(status)}>
        <InnerTagWrapper>
          <span>{t(status)}</span>
          {isEditable && <Icon i={isOpen ? 'CaretUp' : 'CaretDown'} />}
        </InnerTagWrapper>
      </Tag>
    </Popover>
  );
};
